'format es6';

import $ from 'jquery';

/**
 * Simple function to push events to Google Tag Manager for the 'test cursus' event.
 * 
 * @param {String} network
 */
function googleLog(network) {
	dataLayer.push({
		'event': 'customEvent',
		'eventCategory': 'Cursus',
		'eventAction': 'partage',
		'eventLabel': network
	});
}

/**
 * Creates share buttons with the right settings provided by a JSON 
 * object near the node it's called in. Meant to be used in a 
 * $.each() loop.
 *
 * @param {Number} i - Index in the loop
 * @param {*} node - DOM Node or jQuery Object
 */
function shareSnippet(i, node) {
	const snippet = $(node);
	const data = JSON.parse(snippet.siblings('[data-share]').html());

	// If we have specific data for facebook, treat it accordingly
	if (data.facebook !== undefined) {
		snippet.find('[data-facebook]').on('click.cursus', (e) => {
			e.preventDefault();

			googleLog('facebook');
			FB.ui({
				method: 'feed',
				link: data.url,
				caption: 'Université de Montréal',
				name: data.facebook.name,
				description: data.facebook.description,
				picture: data.facebook.picture
			}, (response) => {

			});
		});

		snippet.find('[data-twitter]').on('click.cursus', (e) => {
			e.preventDefault();

			googleLog('twitter');
			const url = `https://twitter.com/intent/tweet/?text=${encodeURI(data.twitter)}`;
			window.open(url, data.name, 'width=560,height=250');
		});
	} else {
		snippet.find('[data-facebook]').on('click.cursus', (e) => {
			e.preventDefault();

			googleLog('facebook');
			FB.ui({
				method: 'feed',
				link: data.url,
				caption: 'Université de Montréal',
				name: data.name,
				picture: data.picture
			}, (response) => {

			});
		});

		snippet.find('[data-linkedin]').on('click.cursus', (e) => {
			e.preventDefault();

			googleLog('linkedin');
			const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(data.url)}&text=${encodeURI(data.name)}`;
			window.open(url, data.name, 'width=520,height=570');
		});

		snippet.find('[data-twitter]').on('click.cursus', (e) => {
			e.preventDefault();

			googleLog('twitter');
			const url = `https://twitter.com/intent/tweet/?url=${encodeURI(data.url)}&text=${encodeURI(data.name)}`;
			window.open(url, data.name, 'width=560,height=250');
		});
	}
}

/**
 * Exported object to use within sections.
 */
export default {
	/**
	 * Inits each share snippets in the page.
	 */
	init() {
		$('[data-share-snippet]').each(shareSnippet);
	},

	/**
	 * Refresh a share snippet in particular
	 * 
	 * @param {*} node - DOMNode or jQuery Object
	 */
	refresh(node) {
		shareSnippet(null, $(node));
	},
};
